import { Type } from 'class-transformer';
import { IsNotEmpty, IsOptional, ValidateNested } from 'class-validator';
import { RegionEntity } from '../../../core/entity/RegionEntity';
import { SiteEntity } from '../../../core/entity/SiteEntity';
import i18n from '../../../i18n';
import { AnalyticsAccessEntity } from '../../../core/entity/AnalyticsAccessEntity';
import { FeatureEntity } from '../../../services/FeatureService';

/** class-validator model for organization edit form (name, org id, regions, sites). */
export class OrganizationEditValidation {
    @IsNotEmpty({
        message: () => i18n.t('validation:isNotEmpty', { field: i18n.t('common:orgName') }),
    })
    name: string;

    @IsOptional()
    organization_id: string | null = null;

    @Type(() => RegionEntity)
    regions: RegionEntity[] = [];

    @ValidateNested({ each: true })
    @Type(() => SiteEntity)
    all_sites: SiteEntity[] = [];

    @IsNotEmpty()
    pricingTierId: string;

    @IsOptional()
    analyticsAccessIds: string[];

    features?: FeatureEntity[];
}
